import SettingsCard from '../settings_card'
import CategoryField from './categories/category_field'
import { mapAssignedCategory } from './categories/category_helpers'
import { CHILD_ENTITY_LABEL } from '../../constants/group_asset_types'
import useUtilities from '../../hooks/use_utilities'

const PREROLL_CONTENT_TYPES = ['movie', 'episode', 'series', 'track']

const PrerollCard = ({ asset, cycleID, langID }) => {
  const { assetTypes } = useUtilities()
  const assetType = asset?.asset_type
  const showContentPrerolls = PREROLL_CONTENT_TYPES.includes(assetType)
  const showPrerollAdPools = assetType === 'ad' && asset?.is_preroll_ad

  if (!showContentPrerolls && !showPrerollAdPools) return null

  const categories = asset.categories ?? []
  const warningSlateCategories = categories.filter((cat) => cat.type === 'warning-slates')
  const prerollCategories = categories.filter((cat) => cat.type === 'ad-pools')
  const availableWarningSlates = asset.available_warning_slates ?? []
  const availablePreroll = asset.available_preroll ?? []

  const isChildOverride = Boolean(asset?.parent_asset_type)
  const childNoun = assetTypes.find((type) => type.value === assetType)?.label?.toLowerCase() || assetType || 'asset'
  const childPlural = CHILD_ENTITY_LABEL[asset?.parent_asset_type] || `${childNoun}s`
  const title = isChildOverride ? 'Pre-roll override' : 'Pre-roll'
  const description = isChildOverride
    ? `By default, ${childPlural} inherit ad sets and slate sets from their parent asset. You can optionally override these on this ${childNoun}.`
    : 'Ad sets and slate sets for this asset.'

  return (
    <SettingsCard title={title} description={description}>
      {showContentPrerolls ? (
        <>
          <CategoryField
            title='Ad set'
            options={availablePreroll}
            value={prerollCategories.map((category) => mapAssignedCategory(category, categories, langID))}
            key='prerolls'
            assetID={asset.id}
            cycleID={cycleID}
            langID={langID}
            type='ad-pools'
          />
          <CategoryField
            title='Slate set'
            options={availableWarningSlates}
            value={warningSlateCategories.map((category) => mapAssignedCategory(category, categories, langID))}
            key='warning-slates'
            assetID={asset.id}
            cycleID={cycleID}
            langID={langID}
            type='warning-slates'
          />
        </>
      ) : (
        <CategoryField
          title='Ad set'
          options={availablePreroll}
          value={prerollCategories.map((category) => mapAssignedCategory(category, categories, langID))}
          key='ad-pools'
          assetID={asset.id}
          cycleID={cycleID}
          langID={langID}
          type='ad-pools'
          isMulti={true}
        />
      )}
    </SettingsCard>
  )
}

export default PrerollCard
